<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f022-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">It is still possible to find some of the original Michelin road signs in this part of France. This one is near Sailly-sur-la-Lys</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 35_fm043.vue?d8bfa2a4